<template>
    <div>
        <multiselect v-model="DisplayValue" :options="options" :multiple="false" track-by="name" :clear-on-select="false" :show-labels="false" label="name" v-bind:placeholder="$t('CountryDropdown.SelectOption')" :preselect-first="true" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
           
        </multiselect>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import clickMixin from '@/Mixins/clickMixin'

    export default {
        mixins: [clickMixin],

        name: 'CountryDropdown',
        props: ["values"],

        components: {
            Multiselect,
            
        },
        data: function () {
            return {
                options: [],
                value: '',
               id:'',
                show: false,
                type: '',
              
                render: 0
            }
        },
        validations: {
          
        },
        methods: {
            getData: function () {
                var root = this;
                var url = 'https://geodata.solutions/api/api.php';
               
                
                this.$https.get(url + '?type=getCountries' ).then(function (response) {
                    
                    if (response.data != null) {
                        for (const [key, value] of Object.entries(response.data.result)) {
                            root.options.push({
                                id: key,
                                name: value
                            });
                        }

                       
                    }
                }).then(function () {
                    root.value = root.options.find(function (x) {
                        return x.id == root.values;
                    })
                });
               
            },
        },
        computed: {
            DisplayValue: {
                get: function () {

                    if (this.value != "" || this.value != undefined) {
                        
                        return this.value;
                    }
                    return this.value;
                },
                set: function (value) {
                    
                    this.value = value;
                    this.$emit('input', value);
                }
            }
        },
        mounted: function () {
            this.getData();
        },
    }
</script>